const TransferEmployeeTypes = {
	/** ****************************** ADD EMPLOYEE *********************** */
	TRANSFER_EMPLOYEE_START: 'transfer_employee_start',
	TRANSFER_EMPLOYEE_SUCCESS: 'transfer_employee_success',
	TRANSFER_EMPLOYEE_FAILURE: 'transfer_employee_failure',
	TRANSFER_EMPLOYEE_RESPONSE_CHANGED: 'transfer_employee_response_changed',
	TRANSFER_EMPLOYEE_RESPONSE_REST_START: 'transfer_employee_response_rest_start',
	
	/** ****************************** GET ALL TRANSFERS *********************** */
	GET_ALL_TRANSFERS_START: 'get_all_transfers_start',
	GET_ALL_TRANSFERS_SUCCESS: 'get_all_transfers_success',
	GET_ALL_TRANSFERS_FAILURE: 'get_all_transfers_failure',
	GET_ALL_TRANSFERS_RESPONSE_REST_START: 'get_all_transfers_response_rest_start',
	
	/** ****************************** DELETE TRANSFER *********************** */
	DELETE_TRANSFER_START: 'delete_transfer_start',
	DELETE_TRANSFER_SUCCESS: 'delete_transfer_success',
	DELETE_TRANSFER_FAILURE: 'delete_transfer_failure',
	DELETE_TRANSFER_RESPONSE_REST_START: 'delete_transfer_response_rest_start',
};

export default TransferEmployeeTypes;
